import { shouldRetryHttpNetworkError, NETWORK_RETRY_BASE_DELAY_MS, NETWORK_RETRY_MAX_ATTEMPTS } from '@/src/app/utils/http-network.utils';
import { attachHttpMethod } from '@/src/app/utils/sentry-error.utils';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { retry, tap } from 'rxjs/operators';

@Injectable()
export class NetworkRetryInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: NETWORK_RETRY_MAX_ATTEMPTS,
        delay: (error, retryCount) => {
          if (!shouldRetryHttpNetworkError(request, error)) {
            return throwError(() => error);
          }
          return timer(NETWORK_RETRY_BASE_DELAY_MS * retryCount);
        }
      }),
      tap({
        error: error => attachHttpMethod(error, request.method)
      })
    );
  }
}
